import React, { useEffect, useState } from 'react'
import { Chip, FormControlLabel, RadioGroup, Radio, Typography, Slide } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import Shakey from './Shakey'
import {shouldDisplayQuestionId} from './Settings'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
  chipRoot: {
    height: 'auto'
  },
  chipLabel: {
    whiteSpace: 'normal',
    paddingTop: '8px',
    paddingBottom: '8px'
  },
  controlLabel: {
    lineHeight: '1.3',
    fontSize: '0.9rem'
  },

}));

const MultipleChoiceQuestion = ({
  animated = true,
  cheat = false,
  answer: selectedAnswer,
  question,
  onChange
}) => {
  const classes = useStyles()

  return (
    <RadioGroup
      name="answer"
      value={selectedAnswer}
      onChange={e => onChange(e.target.value)}
      style={{
        flexGrow: 1,
        gap: '0.5rem 0'
      }}
    >
      {question.answers.map((answer, index) => {
        return (
          <Slide
            key={`${question.id}-${answer.id}`}
            in
            direction="right"
            timeout={250 * (index+1)}
          >
            <FormControlLabel
              value={answer.id}
              classes={{ label: classes.controlLabel }}
              style={{ minHeight: '2rem' }}
              label={
                answer.text
              }
              control={<Radio />}
            />
          </Slide>
        )
      })}
    </RadioGroup>
  )
}

const QuestionBody = props => {
  switch (props.question.type) {
    case 'MultipleChoiceQuestion':
      return <MultipleChoiceQuestion {...props} />
    default:
      return null
  }
}

export default ({ answer, question, onChange }) => {
  const { path } = question

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, gap: '1rem 0' }}>
      <div className="QuizQuestion__Body">
        <Typography variant="body2" style={{ textAlign: 'justify' }}>
          {question.text.trim()}
        </Typography>
      </div>

      <QuestionBody
        answer={answer}
        question={question}
        onChange={onChange}
        style={{ flexGrow: 1 }}
      />

      {shouldDisplayQuestionId() && (
        <Typography variant="caption" style={{ marginBottom: '1rem' }}>{question.id}</Typography>
      )}
    </div>
  )
}